import React from 'react';
import { Card } from '../components/ui/card';

function ShippingPolicyPage() {
  return (
    <div className="min-h-screen py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl font-display font-normal mb-8">Shipping Policy</h1>
        
        <Card className="p-6 space-y-6">
          <section>
            <h2 className="text-xl font-semibold mb-3">Free Delivery on All Orders</h2>
            <p className="text-muted-foreground">
              We offer <strong>FREE delivery</strong> on all orders across India with no minimum purchase requirement. 
              Your happiness is our priority!
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Processing Time</h2>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Orders placed before 2 PM are dispatched the same day</li>
              <li>Orders placed after 2 PM are dispatched the next business day</li>
              <li>We process orders Monday-Saturday (except public holidays)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Delivery Timeline</h2>
            <p className="text-muted-foreground">
              All orders are delivered within <strong>3-5 business days</strong> across India.
            </p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground mt-3">
              <li><strong>Metro Cities:</strong> 2-3 business days</li>
              <li><strong>Other Areas:</strong> 3-5 business days</li>
            </ul>
            <p className="text-muted-foreground mt-3">
              Delivery times may vary during peak seasons (festivals, sales) or due to unforeseen circumstances.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Shipping Partners</h2>
            <p className="text-muted-foreground">
              We partner with reliable courier services including Blue Dart, Delhivery, and India Post 
              to ensure your products reach you safely and on time.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Track Your Order</h2>
            <p className="text-muted-foreground">
              Once your order is dispatched, you'll receive a tracking number via WhatsApp and email. 
              You can track your order status in the "My Orders" section.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Delivery Areas</h2>
            <p className="text-muted-foreground">
              We currently deliver pan-India. If you're in a remote location, delivery may take 1-2 additional days.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
            <p className="text-muted-foreground">
              For shipping queries, contact us:
            </p>
            <ul className="list-none space-y-1 text-muted-foreground mt-2">
              <li><strong>F Square Media</strong></li>
              <li>Address: Panchsheel Park, New Delhi - 110017</li>
              <li>Email: motheringin@gmail.com</li>
              <li>Phone/WhatsApp: +91 80621 80632</li>
            </ul>
          </section>
        </Card>
      </div>
    </div>
  );
}

export default ShippingPolicyPage;